<template>
  <div class="index-right-menu"
       :style="IndexInfo.isOpenRightMenu ? {} : { width: '0px' }">
    <div class="wrapper">
      <div class="header">{{ currentConfigration.componentTitle }}</div>
      <div class="body"
           :style="getHeightStyle()">
        <component :is="value.propertyComponentName"
                   v-for="(value, key, index) in currentConfigration.propertyData"
                   :key="value.id + index"
                   :CurrentConfigration="currentConfigration"
                   :propertyDataKey="key"
                   :propertyData="currentConfigration.propertyData"></component>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { nanoid } from 'nanoid';
const _AutoComponents = {};
/* 动态导入组件函数 start */
let _AutoImport_propertiesComponents = () => {
  const path = require('path');
  const files = require.context('@/components/properties', true, /\.vue$/);
  files.keys().forEach(key => {
    const name = path.basename(key, '.vue');
    _AutoComponents[name] = files(key).default || files(key);
  });
};
_AutoImport_propertiesComponents();

// console.log('导入的组件列表 _AutoImport_propertiesComponents');
console.log(_AutoComponents, 'kk  _AutoComponents');
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'IndexRightMenu',
  components: {
    ..._AutoComponents,
  },
  props: {
    CurrentConfigration: Object,
  },
  data () {
    return {
      currentConfigration: null,
    };
  },
  computed: {
    ...mapState({
      IndexInfo: state => state.IndexInfo,
      ProjectInfo: state => state.ProjectInfo,
    }),
  },
  created () {
    this.currentConfigration = this.$_.cloneDeep(this.CurrentConfigration);
    for (let key in this.currentConfigration.propertyData) {
      this.currentConfigration.propertyData[key].id = nanoid();
    }
  },
  watch: {
    CurrentConfigration (newVal) {
      console.log('New!!! CurrentConfigration ^_^');

      this.currentConfigration = this.$_.cloneDeep(newVal);
      console.log(this.currentConfigration);
      for (let key in this.currentConfigration.propertyData) {
        this.currentConfigration.propertyData[key].id = nanoid();
      }
    },
  },
  methods: {
    ...mapMutations(['set_IndexInfo']),
    getHeightStyle () {
      return {
        height: this.$store.state.ClientViewSize.height - 80 + 'px',
      };
    },
  },
};
</script>


<style lang="scss" scoped>
.index-right-menu {
  width: 280px;
  height: 100%;
  transition: all 0.3s ease-out;
  overflow: hidden;
  user-select: none;

  .wrapper {
    width: 280px;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .header {
      width: 100%;
      height: 40px;
      line-height: 40px;
      white-space: nowrap;
      text-align: center;
      font-size: 14px;
      color: $font-color-base;
      user-select: none;
      background-color: #2c2e3f;
    }
    .body {
      box-sizing: border-box;
      width: 280px;
      background-color: #20212b;
      // height: 100%;
      // overflow: hidden;
      overflow-y: scroll;
      padding: 20px 0px 50px 0px;
      &::-webkit-scrollbar-thumb {
        background: #191e29 !important;
        width: 4px !important;
        height: 3px !important;
      }
      &::-webkit-scrollbar {
        width: 4px !important;
        height: 3px !important;
      }
      &::-webkit-scrollbar-track {
        background: #43455800;
      }
      &::-webkit-scrollbar-corner {
        background-color: #20212b;
      }
    }
  }
}
</style>